export default __webpack_public_path__ + "static/media/FairAndResistant.1dae2c56.png";